module.exports = __webpack_public_path__ + "static/media/D.8b536ea6.png";